import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { pathname } from '../../../../utils';
import { useHistory } from 'react-router';
import { resubmitApp, mistake, header } from './CommonMessages';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    marginTop: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function NegativeGrowth({ loading, closeDialog, storeName }) {
  const classes = useStyles();
  const history = useHistory();

  const headerReason = (
    <Typography gutterBottom>
      <b>{header}</b>
    </Typography>
  );
  const content = (
    <>
      <Typography>
        Our team reviewed your application and cannot create a Growth Plan for{' '}
        {storeName} over concerns about the expected growth rate, given that the
        number of units you plan to purchase falls short of sales projections,
        putting you at risk of not meeting demand.
      </Typography>
      <Typography>{mistake}</Typography>
      <Typography>{resubmitApp}</Typography>
    </>
  );

  const actions = (
    <LoadingButton
      className={classes.button}
      loading={loading}
      onClick={() => history.push(pathname.lines.url)}
    >
      <b>Go to Lines</b>
    </LoadingButton>
  );

  return (
    <>
      <DialogContent className={classes.root}>
        <>
          {headerReason}
          {content}
        </>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>{actions}</DialogActions>
    </>
  );
}
